import React, { useEffect } from "react"
import {
  change,
  Field,
  FormSection,
  formValueSelector,
  initialize,
  reduxForm,
} from "redux-form"
import { FORM_NAMES } from "constants/index"
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap"
import { SaveButton } from "components/Buttons"
import { SingleSelectField, TextField } from "components/RenderInput"
import { connect } from "react-redux"
import validate from "./countdownClockValidation"
import {
  addCountdownClock,
  getCountdownClock,
  resetCountdownClock,
  updateCountdownClock,
} from "store/actions"
import { mapApiToCountdownClockForm, countdownClockFormToApi } from "../utils"
import PropTypes from "prop-types"
import Preview from "./preview"
import { LoadingIndicator } from "components/LoadingIndicator"

let CountdownClock = props => {
  useEffect(() => {
    if (props.feature.entity_id) {
      props.getCountdownClock(props.feature.entity_id)
    }
    return () => {
      props.resetCountdownClock()
    }
  }, [])

  useEffect(() => {
    if (props.countdownClock) {
      props.initializeForm(mapApiToCountdownClockForm(props.countdownClock))
    }
  }, [props.countdownClock])

  const newDate = new Date()
  const today = `${newDate.getFullYear()}-${
    newDate.getMonth() < 9
      ? "0" + (newDate.getMonth() + 1)
      : newDate.getMonth() + 1
  }-${newDate.getDate() < 10 ? "0" + newDate.getDate() : newDate.getDate()}`

  const handleCountdownClockSubmit = data => {
    if (!props.countdownClock) {
      props.addCountdownClock(
        countdownClockFormToApi({
          ...data.countdown_clock_feature_form,
          order: 0,
          menu_feature: 1,
          eventId: props.selectedEvent ? props.selectedEvent.id : null,
          menu_item_id: props.feature.id,
          userId: props.userId,
          vendorId: props.vendorId,
        })
      )
    } else {
      const date = new Date(
        `${data.countdown_clock_feature_form.date} ${data.countdown_clock_feature_form.hour}:${data.countdown_clock_feature_form.minute} ${data.countdown_clock_feature_form.timeType} `
      )
      props.updateCountdownClock({
        ...props.countdownClock,
        countdown_date: `${data.countdown_clock_feature_form.date} ${
          date.getHours() < 10 ? `0${date.getHours()}` : date.getHours()
        }:${
          date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes()
        }:00`,
        title: data.countdown_clock_feature_form.title,
      })
    }
  }

  return (
    <FormSection name={props.form}>
      {props?.loading ? (
        <LoadingIndicator />
      ) : (
        <Card>
          <CardBody className="shadow-sm">
            <Row>
              <Col>
                <h3>{props.feature.label}</h3>
              </Col>
              {props.isListItem && (
                <Col xs="auto">
                  <SaveButton
                    type="button"
                    content="Cancel"
                    color="light"
                    onClick={props.backButtonHandler}
                  />
                </Col>
              )}
              <Col xs="auto">
                <SaveButton
                  type="button"
                  content="Save"
                  onClick={
                    props.isListItem
                      ? props.handleSubmit(props.handleAddListItem)
                      : props.handleSubmit(handleCountdownClockSubmit)
                  }
                />
              </Col>
            </Row>
            <Row className="mt-3">
              <Col>
                <Card>
                  <CardHeader>
                    <h4>CREATE A TITLE FOR YOUR COUNTDOWN CLOCK</h4>
                  </CardHeader>
                  <CardBody>
                    <Row className="mb-2">
                      <Col>
                        <Field
                          name="title"
                          component={TextField}
                          label="Title"
                        />
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
                <Card>
                  <CardHeader>
                    <h4>SET START DATE/TIME</h4>
                  </CardHeader>
                  <CardBody>
                    <Row className="mb-3">
                      <Col xs="auto" className="my-1">
                        <Field
                          name="date"
                          component={TextField}
                          type="date"
                          min={today}
                        />
                      </Col>
                      <Col xs="auto" className="my-1">
                        <Field
                          name="hour"
                          component={TextField}
                          type="number"
                          min="1"
                          max="12"
                          placeholder="HH"
                        />
                      </Col>
                      <Col xs="auto" className="my-1">
                        <Field
                          name="minute"
                          component={TextField}
                          type="number"
                          min="0"
                          max="59"
                          placeholder="MM"
                        />
                      </Col>
                      <Col
                        xs="auto"
                        className="my-1"
                        style={{ minWidth: "120px" }}
                      >
                        <Field
                          name="timeType"
                          component={SingleSelectField}
                          placeholder="AM/PM"
                          options={[
                            {
                              options: [
                                { label: "AM", value: "AM" },
                                { label: "PM", value: "PM" },
                              ],
                            },
                          ]}
                          isSearchable={false}
                        />
                      </Col>
                      <Col xs="auto" className="my-1">
                        <i
                          className="bx bx-sm bx-x"
                          style={{
                            cursor: "pointer",
                            paddingTop: "7px",
                            color: "#34c38f",
                          }}
                          onClick={() => {
                            props.changeField(
                              "countdown_clock_feature_form.date",
                              null
                            )
                            props.changeField(
                              "countdown_clock_feature_form.hour",
                              null
                            )
                            props.changeField(
                              "countdown_clock_feature_form.minute",
                              null
                            )
                          }}
                        />
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
                <Row className="my-2">
                  <Col className="d-flex justify-content-center">
                    <SaveButton
                      type="button"
                      content="Save"
                      onClick={
                        props.isListItem
                          ? props.handleSubmit(props.handleAddListItem)
                          : props.handleSubmit(handleCountdownClockSubmit)
                      }
                    />
                  </Col>
                </Row>
              </Col>
              <Col xl={4} className="mt-4 custom-features-preview">
                <Preview
                  bgImage={props.design?.bg_image_url}
                  title={props.formValues?.title}
                  fontColor={props.design?.menu_font_color}
                  date={props.formValues?.date}
                  hour={props.formValues?.hour}
                  minute={props.formValues?.minute}
                  timeType={props.formValues?.timeType}
                />
              </Col>
            </Row>
          </CardBody>
        </Card>
      )}
    </FormSection>
  )
}

CountdownClock = reduxForm({
  form: FORM_NAMES.COUNTDOWN_CLOCK_FEATURE,
  validate,
  initialValues: {
    countdown_clock_feature_form: {
      timeType: "AM",
    },
  },
})(CountdownClock)

const selector = formValueSelector(FORM_NAMES.COUNTDOWN_CLOCK_FEATURE)

const mapStateToProps = state => ({
  countdownClock: state.CountdownClock.countdownClock,
  loading: state.CountdownClock.loading,
  vendorId: state.Login.vendorId,
  userId: state.Login.authUser.id,
  selectedEvent: state.experiences.selectedEvent,
  formValues: selector(state, "countdown_clock_feature_form"),
})

const mapDispatchToProps = dispatch => ({
  changeField: (field, value) =>
    dispatch(change(FORM_NAMES.COUNTDOWN_CLOCK_FEATURE, field, value)),
  getCountdownClock: values => dispatch(getCountdownClock(values)),
  resetCountdownClock: () => dispatch(resetCountdownClock()),
  initializeForm: values =>
    dispatch(
      initialize(FORM_NAMES.COUNTDOWN_CLOCK_FEATURE, {
        countdown_clock_feature_form: values,
      })
    ),
  addCountdownClock: values => dispatch(addCountdownClock(values)),
  updateCountdownClock: values => dispatch(updateCountdownClock(values)),
})

CountdownClock.propTypes = {
  feature: PropTypes.object,
  handleAddListItem: PropTypes.func,
  isListItem: PropTypes.bool,
  backButtonHandler: PropTypes.func,
}

export default connect(mapStateToProps, mapDispatchToProps)(CountdownClock)
